export { DetailsUI } from './Details';
